import { baseClient } from './baseRequest';

export type ProductMockTemplate = {
  id: string;
  fileName: string;
  previewImageUrl: string;
  generateImageUrl: string;
};

export type PaginatedProductMockTemplates = {
  data: ProductMockTemplate[];
  total: number;
  skip: number;
  limit: number;
};

export type ProductMockTemplatesApiClient = {
  getTemplates: (
    skip?: number,
    limit?: number,
  ) => Promise<PaginatedProductMockTemplates>;
};

const productMockTemplatesApiClient: ProductMockTemplatesApiClient = {
  getTemplates: async (skip = 0, limit = 20) => {
    return baseClient.get<PaginatedProductMockTemplates>({
      url: `/studio/mock-templates`,
      params: { skip, limit },
    });
  },
};

export default productMockTemplatesApiClient;
